import { defineAction } from '~/prix'
import { z } from 'zod'
import propertyMachineryFetchAction from './propertyMachineryFetch.action.json' with { type: 'json' }
import { propertyMachineryObject } from '../propertyMachineryObject'

const propertyMachineryFetchDefinition = defineAction({
  ...propertyMachineryFetchAction,

  input: z.object({
    id: z.string().uuid(),
  }),
  output: propertyMachineryObject,
})

export default propertyMachineryFetchDefinition
